<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h3>Using the App</h3>

      <p>The following explains how the application can be used.</p>

      <main-screen />
      <new-conversation-screen />
      <chat-screen />
    </div>

  </section>

</template>

<script lang="js">
  import MainScreen from './main';
  import ChatScreen from './chat';
  import NewConversationScreen from './newConversation';
  export default  {
    name: 'demo',
    components: {
      "main-screen": MainScreen,
      "chat-screen": ChatScreen,
      "new-conversation-screen": NewConversationScreen,
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>